export default "__VITE_ASSET__DDA8qgXe__"